<script lang="ts" setup>
export interface WizardButtonProps {
    title?: string
    wizardApiUrl: string
    color: Colors
}

const props = withDefaults(defineProps<WizardButtonProps>(), {
    title: undefined,
})

const dropdownsOpenState = useDropdowns()
const { data, sendEvent } = useTracker()

const showModal = ref<boolean>(false)

const attrs = useAttrs()

const position = 'Wizard'

const handleOpen = () => {
    showModal.value = true
    dropdownsOpenState.value.menu = false
    sendEvent({
        data: {
            ...data,
            position,
            title: props.title || '',
            click: 'open',
        },
    })
}

const handleClose = () => {
    showModal.value = false
    sendEvent({
        data: {
            ...data,
            position,
            title: props.title || '',
            click: 'close',
        },
    })
}
</script>
<template>
  <VButton
    type="button"
    :color="props.color"
    v-bind="attrs"
    @click="handleOpen"
  >
    <slot name="title">
      {{ props.title }}
    </slot>
  </VButton>

  <Modal
    v-if="showModal"
    :is-open="showModal"
    size="xxl"
    @close="handleClose"
  >
    <Tracker :data="{ position: `${position} / ${props.title}` }">
      <WidgetWizard :api-url="props.wizardApiUrl" />
    </Tracker>
  </Modal>
</template>
